import dynamic from "next/dynamic";
const Markdown = dynamic(() => import("markdown-to-jsx"));
import Link from "next/link";

import styles from "./LinkListItem.module.scss";

export default function LinkListItem({ item }) {
  return (
    <li className={`${styles.container}`}>
      <Link href={item.link} target={item.target} className={`${styles.link}`}>
        {item.name}
      </Link>
      {item.description && <Markdown>{item.description}</Markdown>}
    </li>
  );
}
